import FormularioMotorCalculo from '../../components/motorcalculo/FormularioMotorCalculo';

const MotorCalculo = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Cálculo de notas</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Motor de cálculo de notas académicas
      </p>
    </div>
    <FormularioMotorCalculo />
  </div>
);

export default MotorCalculo;
